import { IEntity } from '../interfaces/entity';
import { User } from '../models/user';
import { SubjectType } from './subject-type';

export interface INoteTypeList {
  items: NoteType[];
  totalCount: number;
}
export class NoteType implements IEntity {
  id: number;
  uid: string;
  name: string;
  hideRecord: boolean = false;
  subjectTypeId: number = -1;
  subjectType: SubjectType = null;

  canDelete: boolean;
  selected: boolean = false;

  constructor(nt?) {
    nt = nt || {};
    this.id = nt.id;
    this.canDelete = nt.canDelete;
    this.name = nt.name;
    this.hideRecord = nt.hideRecord;
    this.subjectTypeId = nt.subjectTypeId;
    this.subjectType = nt.subjectType;
    this.canDelete = nt.canDelete;
    this.selected = nt.selected;
  }
}

export interface INoteList {
  items: Note[];
  totalCount: number;
}
export class Note implements IEntity {
  id: number;
  uid: string;
  detail: string;
  sensitive: boolean;
  starred: boolean;
  important: boolean;
  labels: string;
  noteTypeId: number;
  dateCreated: string;
  createdById: number;
  user: User;

  noteType: NoteType;

  constructor(note?) {
    note = note || {};
    this.id = note.id;
    this.uid = note.uid;
    this.detail = note.detail || '';
    this.sensitive = note.sensitive || false;
    this.starred = note.starred || false;
    this.important = note.important || false;
    this.labels = note.labels || '';
    this.noteTypeId = note.noteTypeId;
    this.dateCreated = note.dateCreated || '';
    this.createdById = note.createdById;
    if (note.user) {
      this.user = new User(note.user);
    }
    else {
      this.user = new User();
      this.user.firstName = 'Unspecified';
      this.user.lastName = 'User';
    }
    this.noteType = note.noteType;
  }

  toggleStar() {
    this.starred = !this.starred;
  }

  toggleSensitive() {
    this.sensitive = !this.sensitive;
  }

  toggleImportant() {
    this.important = !this.important;
  }
}
